import * as s from "./website-content.scss";
import {
    Component
} from "../../../../../sedestral/framework/interface/component/Component";
import {WebsiteBlackPresentationComponent} from "../black/presentation/WebsiteBlackPresentationComponent";
import {NetworkVendor} from "../../../../../network/NetworkVendor";
import {WebsiteBlackFlowGridComponent} from "../black/flow/grid/WebsiteBlackFlowComponent";
import {WebsiteBlackWorkflowComponent} from "../black/workflow/WebsiteBlackWorkflowComponent";
import {Resources} from "../../../../../resources/Resources";
import {WebsiteBlackStepsComponent} from "../black/steps/WebsiteBlackStepsComponent";
import {WebsiteBlackTextComponent} from "../black/text/WebsiteBlackTextComponent";

export class WebsiteContentTopicsComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteContent}">
                <div class="${s.content}">
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackPresentationComponent({
                            startText: Resources.t("words.topicsStartText"),
                            title: Resources.t("words.topicsTitle"),
                            description: Resources.t("words.topicsDescription"),
                            people: false,
                            center: true,
                            background: "topics"
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackStepsComponent({
                            contents: [
                                {
                                    name: Resources.t("words.topicsIdentifyKeywords"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-an.mp4"),
                                    duration: 22000
                                },
                                {
                                    name: Resources.t("words.topicsVisualizeCoverage"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-ao.mp4"),
                                    duration: 21000
                                }, {
                                    name: Resources.t("words.topicsCreateContent"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-ap.mp4"),
                                    duration: 29000
                                }, {
                                    name: Resources.t("words.topicsTrackPerformance"),
                                    type: "video",
                                    path: NetworkVendor.image("blog-aq.mp4"),
                                    duration: 7000
                                }
                            ],
                            center: true
                        }))}
                    </div>
                    <div class="${s.container}">
                        ${this.draw(new WebsiteBlackTextComponent({
                            text: Resources.t("words.dailyOptimizationUsers"),
                            size: "sizeMid",
                            shadow: "colorBlue"
                        }))}
                    </div>
                </div>
                <div class="${s.white}">
                    <div class="${s.content}">
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackFlowGridComponent({
                                title: Resources.t("words.topicsOutperformCompetitors"),
                                titleMaxWidth: 600,
                                description: Resources.t("words.topicsClusterDescription"),
                                lines: [
                                    {
                                        entries: [
                                            {
                                                title: Resources.t("words.topicsMissingKeywords"),
                                                description: Resources.t("words.topicsMissingKeywordsDescription"),
                                                image: NetworkVendor.image("blog-ad.svg"),
                                                imageAlt: Resources.t("words.topicsImageAltMap"),
                                                imageLeftBottom: true
                                            }, {
                                                title: Resources.t("words.topicsBestOpportunities"),
                                                description: Resources.t("words.topicsBestOpportunitiesDescription"),
                                                illustration: "topicsFire"
                                            }, {
                                                title: Resources.t("words.topicsStrengthenAuthority"),
                                                description: Resources.t("words.topicsStrengthenAuthorityDescription"),
                                                illustration: "topicsShield"
                                            }
                                        ]
                                    }
                                ]
                            }))}
                        </div>
                        <div class="${s.container}">
                            ${this.draw(new WebsiteBlackWorkflowComponent())}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
